/* tslint:disable:no-any */

export default class Event {
  currentTarget: any;

  static COMPLETE: string = 'complete';

  static CHANGE_PROPERTY: string = 'changeProperty';

}
